// Which component each v2 screen key renders.
//
// Separate from nav.js on purpose: nav.js is the IA (labels, icons, gating) and this
// is the wiring. Keeping them apart means adding a screen does not risk the menu
// structure, and the shell can render a nav item before its screen exists.
import DashboardScreen from "../screens/dashboard/DashboardScreen";
import OrganizationsScreen from "../screens/organizations/OrganizationsScreen";
import UploadScreen from "../screens/organizations/UploadScreen";
import AdminUsersScreen from "../screens/organizations/AdminUsersScreen";
import DownloadsScreen from "../screens/organizations/DownloadsScreen";
import NotificationsScreen from "../screens/organizations/NotificationsScreen";
import ExternalRiskScan from "../screens/scanner/ExternalRiskScan";
import ProspectingScreen from "../screens/scanner/ProspectingScreen";
import GenerateScanLinkScreen from "../screens/scanner/GenerateScanLinkScreen";
import LeadMagnetScreen from "../screens/scanner/LeadMagnetScreen";
import SavedWidgetsScreen from "../screens/scanner/SavedWidgetsScreen";
import TemplateHubScreen from "../screens/templates/TemplateHubScreen";
import AdministrationScreen from "../screens/settings/AdministrationScreen";
import ProfileScreen from "../screens/settings/ProfileScreen";
import TwoFactorScreen from "../screens/settings/TwoFactorScreen";
import BrandingScreen from "../screens/settings/BrandingScreen";
import ThresholdsScreen from "../screens/settings/ThresholdsScreen";
import IntegrationsScreen from "../screens/settings/IntegrationsScreen";
import FeatureRequestsScreen from "../screens/settings/FeatureRequestsScreen";
import AssessmentsScreen from "../screens/reviews/AssessmentsScreen";
import ReviewTemplatesScreen from "../screens/reviews/ReviewTemplatesScreen";
import ReviewScheduleScreen from "../screens/reviews/ReviewScheduleScreen";
import LatestScansScreen from "../screens/reviews/LatestScansScreen";
import OverviewScreen from "../screens/reviews/OverviewScreen";
import Placeholder from "../screens/Placeholder";

export const SCREENS = {
  dashboard:     DashboardScreen,

  organizations: OrganizationsScreen,
  upload:        UploadScreen,
  "admin-users": AdminUsersScreen,
  downloads:     DownloadsScreen,
  notifications: NotificationsScreen,

  scan:          ExternalRiskScan,
  prospecting:   ProspectingScreen,
  "scan-links":  GenerateScanLinkScreen,
  "lead-magnet": LeadMagnetScreen,
  widgets:       SavedWidgetsScreen,

  templates:     TemplateHubScreen,

  // Business reviews. The assessment editor is not registered: it needs to know WHICH
  // assessment, and screen keys carry no parameters, so AssessmentsScreen holds it —
  // along with the item drawer, SWOT and comparison, which are all one assessment seen
  // different ways.
  "review-overview":  OverviewScreen,
  assessments:        AssessmentsScreen,
  "review-schedule":  ReviewScheduleScreen,
  "review-templates": ReviewTemplatesScreen,
  "reviews-scans":    LatestScansScreen,

  // Administration is the hub; the six below are its leaves, still resolvable by key so
  // the hub can render them and old ?tab= links keep working.
  administration: AdministrationScreen,
  profile:       ProfileScreen,
  "two-factor":  TwoFactorScreen,
  branding:      BrandingScreen,
  thresholds:    ThresholdsScreen,
  integrations:  IntegrationsScreen,
  requests:      FeatureRequestsScreen,
};

// Menus 2-4 are being built in order. Until a screen exists its nav item resolves to a
// placeholder that says so, rather than rendering blank or falling through to the
// organization list the way v1's switch did.
export const resolveScreen = (key) => SCREENS[key] || Placeholder;
